import { $RootStore } from '../RootStore'
import { GettingStartedStepIds } from '../../../shared-solo/stores/SetupStore/stepData/gettingStarted'
import { GMBOnboardingStepIds } from '../../../shared-solo/stores/SetupStore/stepData/gmbOnboardingSteps'
import { MarketingToolsStepIds } from '../../../shared-solo/stores/SetupStore/stepData/marketingTools'
import { PaymentsAndDepositsStepIds } from '../../../shared-solo/stores/SetupStore/stepData/paymentsAndDepositsSteps'
import { BookingSystemAdvancedStepIds } from '../../../shared-solo/stores/SetupStore/stepData/bookingSystemAdvancedSteps'
import { PlatformStepData } from '../../../shared-solo/stores/SetupStore/BaseSetupStore'

export const stepData: PlatformStepData[] = [
  {
    id: GettingStartedStepIds.locations,
    check: (rootStore: $RootStore) => {
      const { pathname } = rootStore.navigationStore

      const isOnLocationsPage = pathname.includes('/booking-system/locations')
      if (!isOnLocationsPage) return false

      const isCreatingLocation = pathname.includes('/new')
      if (isCreatingLocation) return false

      const { saasSettings } = rootStore.userStore.data.professionalProfile

      return saasSettings.mobileLocation?.enabled || (saasSettings.staticLocations || [])?.filter(s => s.enabled).length > 0
    },
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/booking-system/locations')
    },
  },
  {
    id: GettingStartedStepIds.inviteTeam,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/team')
    },
  },
  {
    id: GettingStartedStepIds.treatments,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/booking-system/treatments')
    },
  },
  {
    id: GettingStartedStepIds.website,
    check: (rootStore: $RootStore) => {
      // Check if the home page is created
      return !!rootStore.webPageStore.webPageByPath('home')?.data._id
    },
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/website')
    },
  },
  {
    id: GettingStartedStepIds.addBooking,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/calendar')
    },
  },
  // GMB Onboarding
  {
    id: GMBOnboardingStepIds.profileAnalyser,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/google-business-profile')
    },
  },
  {
    id: GMBOnboardingStepIds.syncReviews,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/booking-system/reviews')
    },
  },
  {
    id: GMBOnboardingStepIds.websiteOptimisation,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/website/seo-analyser')
    },
  },
  // We will introduce these when the features are available
  {
    id: GMBOnboardingStepIds.reviewGathering,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/booking-system/booking-updates')
    },
  },
  // {
  //   id: GMBOnboardingStepIds.servicePages,
  //   startAction: async (rootStore: $RootStore) => {
  //     rootStore.navigationStore.unsupported_navigate('/google-business-profile/reviews')
  //   },
  // },
  // Marketing Tools
  {
    id: MarketingToolsStepIds.promocode,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/booking-system/promocodes/list/active')
    },
  },
  {
    id: MarketingToolsStepIds.loyaltyScheme,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/marketing-tools/loyalty-schemes')
    },
  },
  {
    id: MarketingToolsStepIds.referralScheme,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/marketing-tools/client-referrals')
    },
  },
  {
    id: MarketingToolsStepIds.automatedMessages,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/marketing-tools/automated-messaging')
    },
  },
  {
    id: MarketingToolsStepIds.broadcastMessages,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/marketing-tools/broadcast-emails')
    },
  },
  // Payments & Deposits
  {
    id: PaymentsAndDepositsStepIds.onlineCardPayments,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/payments/stripe')
    },
  },
  {
    id: PaymentsAndDepositsStepIds.depositRules,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/payments/deposit-settings')
    },
  },
  {
    id: PaymentsAndDepositsStepIds.giftCard,
    check: (rootStore: $RootStore) => {
      const { userStore } = rootStore
      return !!userStore.data.professionalProfile?.giftCardSettings?.enabled
    },
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/payments/gift-cards')
    },
  },
  {
    id: BookingSystemAdvancedStepIds.bookingReminders,
    check: (rootStore: $RootStore) => {
      return rootStore.uiStore.seenPrompts.includes(BookingSystemAdvancedStepIds.bookingReminders)
    },
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/booking-system/booking-updates')
    },
  },
  {
    id: BookingSystemAdvancedStepIds.consultationForms,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/booking-system/consultation-forms')
    },
  },
  {
    id: BookingSystemAdvancedStepIds.aftercare,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/booking-system/aftercare')
    },
  },
  {
    id: BookingSystemAdvancedStepIds.cancellationPolicy,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/booking-system/policies')
    },
  },
  {
    id: BookingSystemAdvancedStepIds.termsAndConditions,
    startAction: async (rootStore: $RootStore) => {
      rootStore.navigationStore.unsupported_navigate('/booking-system/policies')
    },
  },
]
